import React from "react";
import StripeAccounts from "../../Components/StripeAccounts";
import PageHeader from "../../Components/Common/PageHeader";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";

const Gateways = () => {
  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Stripe"
          description="Manage Accounts, Settings, ..."
          icon={faCreditCard}
        />

        <StripeAccounts />
      </div>
    </main>
  );
};

export default Gateways;
